import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage} from '../../../../../../../libs/shared/core/src/helpers/internationalization/message';
import {getUserTimeZone} from '../../../../../../../libs/shared/core/src/store/data/preferences/commonPreferencesSelectors';
import {FieldDescription} from '../../../../../../../libs/shared/ui/src/components/fields/fieldDescription';
import {useAppSelector} from '../../../../../../helpers/appReduxHelpers';
import {DateTimePopoverContainer} from '../../../../../common/createFormInputs/dateTimePopoverContainer';
import {StyledMacroInputDescriptionDiv} from './common/macroInputDropdownStyles';
import {MacroInputCommonProps} from './common/macroInputTypes';

/*
 * Props.
 */

interface MacroInputDateTimeProps extends MacroInputCommonProps<string> {}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

/*
 * Component.
 */

export const MacroInputDateTime: FC<MacroInputDateTimeProps> = ({value, onChange, label, description}) => {
  const localize = useLocalize();
  const userTimeZone = useAppSelector(getUserTimeZone);

  return (
    <StyledWrapperDiv>
      <DateTimePopoverContainer
        key="start-time-vacation-responders-form"
        title={label}
        value={value ?? ''}
        onSelect={(newValue) => {
          if (newValue === '') {
            onChange(undefined);
          }

          onChange(newValue);
        }}
        placeholder={localize(
          defineMessage({
            id: 'macro-input-date-time-placeholder',
            message: 'Select date and time',
          }),
        )}
        customFormat={{dateStyle: 'medium', timeStyle: 'short'}}
        timezone={userTimeZone}
        noMargin
        isRequired
      />
      <FieldDescription
        message={<StyledMacroInputDescriptionDiv>{description}</StyledMacroInputDescriptionDiv>}
        shouldDisableBottomTextMargin
      />
    </StyledWrapperDiv>
  );
};
